import { RouteComponentProps } from '@reach/router';
import _ from "lodash"
import BiDataExport from "components/import-export/bi-data-export";
import Import from "components/import-export/import";
import { ImportExport_s } from 'components/import-export/import-export-styles';
import RdcfExport from "components/import-export/rdcf-export";
import PropertyAEExport from "components/import-export/property-ae-export"
import PDFImport from "components/import-export/pdf-import"
import { local } from 'data/lib/local-json'
import toggles from "feature-toggles"
import { aeExportOrgs, pdfImportOrgs } from "data/config/org-flags"
// Components
import { TabPanel, TabView } from 'primereact/tabview';
import React from "react";
// Styles
import { Tabs_s } from 'styles/tab-styles';

const PropertyImportExport = (props: RouteComponentProps) => {
  const profile         = local('auth.profile')
  const organizationId = _.get(profile, 'organizationId')

  const tabs = [
    <TabPanel header="rDCF Export"><RdcfExport /></TabPanel>,
    <TabPanel header="rDCF Update"><Import /></TabPanel>,
    (toggles.displayAEExport() && (process.env.SWARM_ENV == 'production' ? aeExportOrgs.includes(organizationId) : true)) && <TabPanel header="AE Export"><PropertyAEExport /></TabPanel>,
    (process.env.SWARM_ENV == 'production' ? pdfImportOrgs.includes(organizationId) : true) && <TabPanel header="PDF Import" key="pdfImport"><PDFImport /></TabPanel>,
    <TabPanel header="BI Data Export"><BiDataExport /></TabPanel>
  ].filter(Boolean)

  return (
    <ImportExport_s>
      <Tabs_s>
        <TabView>
          { tabs }
        </TabView>
      </Tabs_s>
    </ImportExport_s>
  )
}

export default PropertyImportExport
